import { ReactComponent as DownArrow } from './down-arrow-head.svg';
import { ReactComponent as InventoryBox } from './inventory.svg';
import { ReactComponent as MensaLogoIcon } from './mensa-logo.svg';
import { ReactComponent as Notification } from './notifications-icon.svg';
import { ReactComponent as PurchasesLogoIcon } from './purchases-icon.svg';
import { ReactComponent as Sales } from './sales-icon.svg';

export const MensaLogo = MensaLogoIcon;
export const PurchasesIcon = PurchasesLogoIcon;
export const SalesIcon = Sales;
export const NotificationIcon = Notification;
export const DownArrowHead = DownArrow;
export const InventoryIcon = InventoryBox;
